import React, { Fragment } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Stepper from '@mui/material/Stepper';
import StepButton from '@mui/material/StepButton';

import Step from '@mui/material/Step';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux'
import {
  obtenerTodasLasSolicitudesWithStatusEnviado,
  AcualizarFormatoAccion, agregarObservacionAccion
} from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import { withRouter } from 'react-router-dom'
import Modal from '@mui/material/Modal';
import { obtenerFC_05Detalle } from '../../../redux/FC_05Ducks';
import { useStateIfMounted } from 'use-state-if-mounted'
import moment from 'moment'
import './NavBarAtencionACliente.css'; { {/*Estilos para el componente*/ } }



import NuevasSVG from '../../../img/nuevas.png';
import EnProcesoSVG from '../../../img/enproceso.png';
import EnviadosSVG from '../../../img/enviadas.png';
import AceptadasSVG from '../../../img/aceptadas.png';
import DenegadoSVG from '../../../img/denegadas.png';
import CorreccionSVG from '../../../img/correccion.png';

import { paginationClasses } from '@mui/material';
import { blue } from '@mui/material/colors';

const iconos = [NuevasSVG, EnProcesoSVG, DenegadoSVG, CorreccionSVG, AceptadasSVG];
const pages = ['Nuevas', 'En proceso', 'Devueltas al usuario', 'Recibidas corregidas', 'Aceptadas'];
const NavBarAtencionACliente = (props) => {

  const dispatch = useDispatch()

  //variables para el formato principal
  const currentUser = useSelector(store => store.Usuario.data)

  const loginIn = localStorage.getItem('user')
  let idUsuario = 0
  if (currentUser) {
    idUsuario = currentUser.user[0].id
  }

  const estilos1 = '2px';
  const estilos0 = '0px';

  const [isActiva1,setIsActiva1] = React.useState(estilos0);
  const [isActiva2,setIsActiva2] = React.useState(estilos0);
  const [isActiva3,setIsActiva3] = React.useState(estilos0);
  const [isActiva4,setIsActiva4] = React.useState(estilos0);
  const [isActiva5,setIsActiva5] = React.useState(estilos0);


  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [activeStep, setActiveStep] = React.useState(0);

  
  const darkTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#263238',
      },
    },
  });



  //ste no se usa
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleMenuOption = async (event) => {
    setAnchorElNav(null);
    let res
    switch (event.currentTarget.innerText) {
      case 'nuevas':
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
        props.history.push('/AtencionAClientesComponent')
        return
      case 'EN PROCESO':
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 3 }))
        props.history.push('/AtencionAClientesComponent')
        return
      case 'DEVUELTAS AL USUARIO':
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 5 }))
        props.history.push('/AtencionAClientesComponent')
        return
      case 'RECIBIDAS CORREGIDAS':
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 6 }))
        props.history.push('/AtencionAClientesComponent')
        return
      case 'ACEPTADAS':
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        props.history.push('/AtencionAClientesComponent')
        return
      default:
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
        props.history.push('/AtencionAClientesComponent')
        return
    }
  }


  const handleMenuOptionDesk = async (page, index) => {
    setActiveStep(index)
    setAnchorElNav(null);
    let res
    switch (page) {
      case 'Nuevas':
        setIsActiva1(estilos1);   
        setIsActiva2(estilos0); 
        setIsActiva3(estilos0); 
        setIsActiva4(estilos0); 
        setIsActiva5(estilos0); 
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
        props.history.push('/AtencionAClientesComponent')
        return
      case 'En proceso':
        setIsActiva1(estilos0);   
        setIsActiva2(estilos1); 
        setIsActiva3(estilos0); 
        setIsActiva4(estilos0); 
        setIsActiva5(estilos0); 
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 3 }))
        props.history.push('/AtencionAClientesComponent')
        return
      case 'Devueltas al usuario':
        setIsActiva1(estilos0);   
        setIsActiva2(estilos0); 
        setIsActiva3(estilos1); 
        setIsActiva4(estilos0); 
        setIsActiva5(estilos0); 
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 5 }))
        props.history.push('/AtencionAClientesComponent')
        return
      case 'Recibidas corregidas':
        setIsActiva1(estilos0);   
        setIsActiva2(estilos0); 
        setIsActiva3(estilos0); 
        setIsActiva4(estilos1); 
        setIsActiva5(estilos0); 
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 6 }))
        props.history.push('/AtencionAClientesComponent')
        return
      case 'Aceptadas':
        setIsActiva1(estilos0);   
        setIsActiva2(estilos0); 
        setIsActiva3(estilos0); 
        setIsActiva4(estilos0); 
        setIsActiva5(estilos1); 
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        props.history.push('/AtencionAClientesComponent')
        return
      default:
        res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
        props.history.push('/AtencionAClientesComponent')
        return
    }
  }
  const handleCloseNavMenu = async (event) => {
    setAnchorElNav(null);
  };

  return (
    <Fragment>
        <AppBar position="static" className='appBar'>
         
            <Toolbar disableGutters>            
              <div className='row text-center'>
                <div style={{borderWidth:isActiva1, borderBottomStyle:'ridge',borderColor:'deepskyblue'}} className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
                        <button type='button' className='btn' onClick={e => handleMenuOptionDesk(pages[0], 0)}>
                          <img  className="img-fluid" src={iconos[0]}></img>
                          <br />
                          <span className='texts'>{pages[0]}</span>
                        </button><br/>
                </div>
                <div style={{borderWidth:isActiva2, borderBottomStyle:'ridge',borderColor:'deepskyblue'}} className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
                        <button type='button' className='btn' onClick={e => handleMenuOptionDesk(pages[1], 1)}>
                          <img  className="img-fluid" src={iconos[1]}></img>
                          <br />
                          <span className='texts'>{pages[1]}</span>
                        </button><br/>
                </div>
                <div style={{borderWidth:isActiva3, borderBottomStyle:'ridge',borderColor:'deepskyblue'}} className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
                        <button type='button' className='btn' onClick={e => handleMenuOptionDesk(pages[2], 2)}>
                          <img  className="img-fluid" src={iconos[2]}></img>
                          <br />
                          <span className='texts'>{pages[2]}</span>
                        </button><br/>
                </div> 
                <div style={{borderWidth:isActiva4, borderBottomStyle:'ridge',borderColor:'deepskyblue'}} className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
                        <button type='button' className='btn' onClick={e => handleMenuOptionDesk(pages[3], 3)}>
                          <img  className="img-fluid" src={iconos[3]}></img>
                          <br />
                          <span className='texts'>{pages[3]}</span>
                        </button><br/>
                </div>
                <div style={{borderWidth:isActiva5, borderBottomStyle:'ridge',borderColor:'deepskyblue'}}  className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
                        <button type='button' className='btn' onClick={e => handleMenuOptionDesk(pages[4], 4)}>
                          <img  className="img-fluid" src={iconos[4]}></img>
                          <br />
                          <span className='texts'>{pages[4]}</span>
                        </button><br/>
                </div>
              </div>
                 
            </Toolbar>
         
        </AppBar>
        <br />
      
    </Fragment>
  );
};


export default withRouter(NavBarAtencionACliente)
